<template>
  <div>
    <v-container fluid>
        <v-card-title class="card-title pa-3" style="border-bottom: 1px solid #C9C9C9;">
            <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">Upload Positive Question Set</h1>
        </v-card-title>
        <v-flex class="flex">
          <div class="form-container">
            <v-row>
              <v-col cols="12" sm="6" md="6" class="custom">
                <v-img
                  :src="images.questionset"
                  width="18"
                  height="18"
                  class="customimg"
                />
                <h1 style="font-weight: bold; font-size: 18px;">Question Set Information</h1>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="d-flex justify-end align-center">
              <!-- Process Button -->
              <v-btn
                id="button-process-validationpositivedetail"
                variant="flat"
                size="default"
                class="process-btn"
                @click="Save()"
                :disabled="!searchPositiveName || !request.entity"
              >
                <v-img :src="images.processImg" width="20" height="20" class="mr-2" />
                Process
              </v-btn>
                <!-- Template Menu -->
              <v-menu location="bottom">
                <template v-slot:activator="{ props }">
                  <v-btn
                    id="template-validationpositivedetail"
                    v-bind="props"
                    variant="outlined"
                    size="default"
                    class="template-btn"
                  >
                  <v-img :src="images.downloadImg" width="20" height="20" class="mr-2"></v-img>
                    Template
                  </v-btn>
                </template>
                
                <v-card min-width="200" elevation="8" rounded="lg">
                  <v-list density="compact" nav class="pa-2">
                    <v-list-item 
                      id="normalquestion-list-validationpositivedetail"
                      class="template-item" 
                      @click="normalDownload"
                    >
                      <template v-slot:prepend>
                        <v-img :src="images.normalImg" width="16" height="16" class="mr-2" />
                      </template>
                      <v-list-item-title class="text-subtitle-2">Normal Question</v-list-item-title>
                    </v-list-item>
                    
                    <v-divider></v-divider>
                    
                    <v-list-item 
                      id="chainquestion-list-validationpositivedetail"
                      class="template-item" 
                      @click="chainTemplate"
                    >
                      <template v-slot:prepend>
                        <v-img :src="images.chainedImg" width="16" height="16" class="mr-2" />
                      </template>
                      <v-list-item-title class="text-subtitle-2">Chain Question</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
              
              <!-- Add Button -->
              <v-btn
                id="button-add-validationpositivedetail"
                variant="flat"
                prepend-icon="mdi-plus"
                class="control-btn create-btn customadd"
                @click="SetAdd()"
              >
                {{ $t("add") }}
              </v-btn>
              </v-col>
            </v-row>
            <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="field-label">
                Question Set Name
                <span style="color: red;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>The name of the set of positive test questions</span>
                </v-tooltip>
              </label>
              <v-text-field
                placeholder="Enter Positive Question Set Name"
                id="questionsetname-field-validationpositivedetail"
                :rules="[rules.required]"
                :disabled="actionEdit"
                v-model="searchPositiveName"
                variant="outlined"
                density="comfortable"
                color="primary"
                class="modern-text-field"
                clearable
                hide-details="auto"
                :readonly="!!pId"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="field-label">
                Upload File
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>Import an Excel (.xlsx) file to import positive question set.</span>
                </v-tooltip>
              </label>
              <div class="form-group upload-section mt-2">
                <div class="upload-container">
                  <v-tooltip text="Import an Excel (.xlsx) file to import positive question set." location="top">
                    <template v-slot:activator="{ props }">
                      <div v-bind="props" class="upload-area">
                        <!-- Upload File Dropdown Menu -->
                        <v-menu location="bottom">
                          <template v-slot:activator="{ props }">
                            <v-btn 
                              id="proxy-upload-button" 
                              v-bind="props"
                              variant="elevated" 
                              size="large"
                              class="upload-main-btn"
                            >
                              <v-img :src="images.uploadImg" width="20" height="20" class="mr-2" />
                              <span class="upload-text">Upload File</span>
                            </v-btn>
                          </template>
                          
                          <v-card min-width="200" elevation="8" rounded="lg">
                            <v-list density="compact" nav class="pa-2">
                              <v-list-item 
                                id="normalquestion-upload-validationpositivedetail"
                                class="template-item" 
                                @click="triggerFileUpload('Normal Question')"
                              >
                                <template v-slot:prepend>
                                  <v-img :src="images.normalImg" width="16" height="16" class="mr-2" />
                                </template>
                                <v-list-item-title class="text-subtitle-2">Normal Question</v-list-item-title>
                              </v-list-item>
                              
                              <v-divider></v-divider>
                              
                              <v-list-item 
                                id="chainquestion-upload-validationpositivedetail"
                                class="template-item" 
                                @click="triggerFileUpload('Chain Question')"
                              >
                                <template v-slot:prepend>
                                  <v-img :src="images.chainedImg" width="16" height="16" class="mr-2" />
                                </template>
                                <v-list-item-title class="text-subtitle-2">Chain Question</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-menu>

                        <!-- Upload Info -->
                        <div class="upload-info">
                          <div class="upload-description">
                            <v-icon size="16" class="mr-1">mdi-information-outline</v-icon>
                            <span class="upload-hint">Support Formats : .xlsx (Max 10 MB)</span>
                          </div>
                        </div>

                        <!-- Display Selected File -->
                        <div v-if="uploadedFiles.length > 0" class="uploaded-file-info">
                          <v-chip variant="elevated" size="small" class="file-chip">
                            <v-img :src="images.excelImg" width="16" height="16" class="mr-2" />
                            {{ uploadedFiles[0].name }}
                            <v-chip v-if="selectedUploadType" size="x-small" class="ml-2" color="primary">
                              {{ selectedUploadType }}
                            </v-chip>
                          </v-chip>
                        </div>
                      </div>
                    </template>
                  </v-tooltip>

                  <!-- Drag Drop File Component -->
                  <DragDropFile 
                    ref="dragDropRef" 
                    :dialog="true" 
                    :DragDrop="false" 
                    :ShowListFile="false" 
                    :DropDown="true"
                    :allowType="validMimeTypes_Excel" 
                    @uploadType="handleUploadType"
                    @filesUploaded="processUpload($event)" 
                    class="modern-upload hidden-upload" 
                  />
                </div>
              </div>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="6">
              <v-card
                v-if="uploadedFiles.length > 0"
                class="files-card"
                elevation="2"
                rounded="lg"
              >
                
                <v-virtual-scroll 
                  :items="uploadedFiles" 
                  :height="Math.min(uploadedFiles.length * 60, 120)" 
                  :item-height="60"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item class="file-item px-4 py-2">
                      <template v-slot:prepend>
                        <v-avatar size="36" color="success" class="mr-3">
                          <v-icon color="white" size="18">mdi-file-excel</v-icon>
                        </v-avatar>
                      </template>

                      <v-list-item-title class="text-subtitle-2 font-weight-medium">
                        {{ item.name }}
                      </v-list-item-title>
                      
                      <v-list-item-subtitle class="text-caption">
                        {{ formatFileSize(item.size) }}
                      </v-list-item-subtitle>

                      <template v-slot:append>
                        <v-btn 
                          @click.stop="removeFile(item.name)" 
                          icon="mdi-close"
                          size="small"
                          variant="text"
                          color="error"
                          class="ml-2"
                        />
                      </template>
                    </v-list-item>
                    <v-divider class="mx-4" v-if="uploadedFiles.indexOf(item) < uploadedFiles.length - 1" />
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-col> -->
          </v-row>
          </div>
          
          <div class="form-container">
            <div class="d-flex justify-space-between mb-3">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">Positive Question Set Table</h1>
              <v-spacer></v-spacer>
              <!-- Delete Selected Button -->
              <v-btn
                v-if="showTable == true && selectedItems.length > 0"
                id="button-deleteselected-validationpositivedetail"
                variant="outlined"
                size="large"
                color="error"
                @click="DeleteSelected"
                class="delete-all-btn"
              >
                <v-img :src="images.trashIcon" width="16" height="16" class="mr-2"></v-img>
                Delete Selected
              </v-btn>
              
              <!-- Delete All Button -->
              <v-btn
                v-if="showTable == true && selectedItems.length == 0"
                id="button-deleteall-validationpositivedetail"
                variant="outlined"
                size="large"
                @click="DeleteByName(pId)"
                class="delete-all-btn"
              >
                <v-img :src="images.trashIcon" width="16" height="16" class="mr-2"></v-img>
                {{ $t("deleteAll") }}
              </v-btn>
            </div>
            
            <v-data-table-server
            v-if="showTable == true"
            :items-per-page="itemsPerPage"
            :items-length="searchTotalTable"
            v-model:options="options"
            :items="dataTable"
            :headers="headers"
            :loading="loadingTable"
            loading-text="Loading..."
          >
            <template v-slot:header.select>
              <v-checkbox
                :model-value="selectedItems.length === dataTable.length && dataTable.length > 0"
                :indeterminate="selectedItems.length > 0 && selectedItems.length < dataTable.length"
                @click="toggleSelectAll"
                hide-details
                density="compact"
                color="#C32E0E"
              ></v-checkbox>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <v-checkbox
                    v-model="selectedItems"
                    :value="item.positiveID"
                    hide-details
                    density="compact"
                    color="#C32E0E"
                  ></v-checkbox>
                </td>
                <td style="width: 81px; text-align: center">
                  {{ item.number }}
                </td>
                <td class="text-ellipsis">{{ item.question }}</td>
                <td class="text-ellipsis">{{ item.answer }}</td>
                <td style="text-align: center">{{ item.questionType }}</td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center;">
                    <!-- Edit Button -->
                    <v-btn
                      id="button-edit-popupedit-validationpositive"
                      variant="text"
                      density="comfortable"
                      @click="SetEdit(item)"
                      class="action-btn edit-btn"
                      icon
                    >
                      <v-img :src="images.editBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        Edit
                      </v-tooltip>
                    </v-btn>
                  
                    <!-- Delete Button -->
                    <v-btn
                      id="button-delete-popupedit-validationpositivedetail"
                      variant="text"
                      density="comfortable"
                      @click="DeleteById(item.positiveID)"
                      class="action-btn delete-btn"
                      icon
                    >
                      <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
            <template #no-data>
              <div style="text-align: center;">
                <span style="color: #646464; font-weight: 400;">No Data Available</span>
              </div>
            </template>
            <!-- 👇 Custom footer area -->
            <template v-slot:bottom>
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div>Total results {{ searchTotalTable }}</div>

                <v-data-table-footer v-model:items-per-page="itemsPerPage" :page="options.page"
                  :length="Math.ceil(searchTotalTable / itemsPerPage)" />
              </div>
            </template>
          </v-data-table-server>
          </div>
        </v-flex>

    </v-container>
    <!-- <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Add Dialog -->
    <v-dialog v-model="dialogAdd.flag" persistent max-width="700px" class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header Section -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">Add Positive Question</h2>
              <p class="dialog-subtitle">Create a new positive question and answer pair</p>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Content Section -->
        <v-card-text class="dialog-content">
          <v-form ref="addForm" lazy-validation>
            <v-row>
              <!-- Question Field -->
              <v-col cols="12" md="6">
                <div class="field-container">
                  <label class="field-label ml-0">
                  Question
                  </label>
                  <v-textarea
                    v-model="dialogAdd.question"
                    :rules="[rules.required]"
                    variant="outlined"
                    rows="8"
                    counter
                    color="primary"
                    class="modern-textarea"
                    hide-details="auto"
                    placeholder="Enter positive question"
                  >
                  </v-textarea>
                </div>
              </v-col>

              <!-- Answer Field -->
              <v-col cols="12" md="6">
                <div class="field-container">
                  <label class="field-label ml-0">
                  Human Answer
                  </label>
                  <v-textarea
                    v-model="dialogAdd.answer"
                    variant="outlined"
                    rows="8"
                    counter
                    color="primary"
                    class="modern-textarea"
                    hide-details="auto"
                    placeholder="Enter human answer"
                  >
                  </v-textarea>
                </div>
              </v-col>

              <!-- Question Type -->
              <v-col cols="12">
                <div class="field-container">
                  <label class="field-label ml-0">
                    Question Type
                    <span style="color: red">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="small"
                          v-bind="props"
                          color="grey-darken-1"
                          class="help-icon"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Select the type of question : Normal or Chain</span>
                    </v-tooltip>
                  </label>
                  <v-select
                    :rules="[rules.required]"
                    :items="questionTypeList"
                    item-title="name"
                    item-value="value"
                    variant="outlined"
                    v-model="dialogAdd.questionType"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    hide-details="auto"
                    placeholder="Select Question Type"
                  >
                  </v-select>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Actions Section -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            variant="outlined"
            color="grey"
            size="large"
            @click="ClearAdd"
            class="dialog-action-btn cancel-btn"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn 
            variant="flat"
            size="large"
            @click="Add"
            class="dialog-action-btn save-btn-add"
          >
            <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog -->
    <v-dialog v-model="dialogEdit.flag" persistent max-width="700px" class="modern-dialog">
      <v-card class="dialog-card" elevation="8">
        <!-- Header Section -->
        <div class="dialog-header dialog-header-edit pa-4">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">Edit Positive Question</h2>
              <p class="dialog-subtitle">Modify the positive question and answer pair</p>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Content Section -->
        <v-card-text class="dialog-content">
          <v-form ref="editForm" lazy-validation>
            <v-row>
              <!-- Question Field -->
              <v-col cols="12" md="6">
                <div class="field-container">
                  <label class="field-label ml-0">
                  Question
                  </label>
                  <v-textarea
                    v-model="dialogEdit.question"
                    :rules="[rules.required]"
                    variant="outlined"
                    rows="8"
                    counter
                    color="primary"
                    class="modern-textarea"
                    hide-details="auto"
                    placeholder="Enter your question here..."
                  >
                  </v-textarea>
                </div>
              </v-col>

              <!-- Answer Field -->
              <v-col cols="12" md="6">
                <div class="field-container">
                  <label class="field-label ml-0">
                    Human Answer
                  </label>
                  <v-textarea
                    v-model="dialogEdit.answer"
                    variant="outlined"
                    rows="8"
                    counter
                    color="primary"
                    class="modern-textarea"
                    hide-details="auto"
                    placeholder="Enter the expected answer here..."
                  >
                  </v-textarea>
                </div>
              </v-col>

              <!-- Question Type -->
              <v-col cols="12">
                <div class="field-container">
                  <label class="field-label ml-0">
                    Question Type
                    <span style="color: red">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="small"
                          v-bind="props"
                          color="grey-darken-1"
                          class="help-icon"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Select the type of question : Normal or Chain</span>
                    </v-tooltip>
                  </label>
                  <v-select
                    :rules="[rules.required]"
                    :items="questionTypeList"
                    item-title="name"
                    item-value="value"
                    variant="outlined"
                    v-model="dialogEdit.questionType"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    hide-details="auto"
                  >
                  </v-select>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Actions Section -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            variant="outlined"
            color="grey"
            size="large"
            @click="ClearEdit"
            class="dialog-action-btn cancel-btn"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn 
            variant="flat"
            size="large"
            @click="EditById"
            class="dialog-action-btn save-btn-edit"
          >
            <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete Confirmation</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem === 'selected'">
            Do you want to confirm deletion of {{ selectedItems.length }} selected question(s)? This action cannot be undone.
          </span>
          <span v-else-if="deleteItem">
            Do you want to confirm deletion of this question? This action cannot be undone.
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete1" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete Confirmation</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span>
            Do you want to confirm deletion of this question? This action cannot be undone.
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete1"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <!-- Custom Warning Dialog -->
    <v-dialog v-model="dialog_warn" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="warn-dialog-header">
          <span class="reprocess-dialog-title">Question Set Name is Required !</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="dialog_warn = false"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          Please fill the positive question set name.
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="reprocess-confirm-btn"
            @click="dialog_warn = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DragDropFile from "@/components/DragDropFile.vue";
import ExcelJS from "exceljs";
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import deleteIcon from "@/assets/images/trash-solid.svg";
import trashIcon from "@/assets/images/trashoutline.png";
import saveImg from '@/assets/images/savecard.png';
import questionset from '@/assets/images/Questionset.png';
import uploadImg from '@/assets/images/uploadcolor.png';
import excelImg from '@/assets/images/file-excel.png';
import processImg from '@/assets/images/process.svg';
import downloadImg from '@/assets/images/downloadtemplate.svg';
import normalImg from '@/assets/images/normalquestion.svg';
import chainedImg from '@/assets/images/chainedquestion.svg';

export default {
  name: "ValidationPositiveDetail",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: { DragDropFile },
  props: ["id"],
  data: () => ({
    selectedUploadType: null,
    isInitialized: false,
    uploadDialog: false,
    checkbox1: false,
    actionEdit: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    today: null,
    searchPositiveName: null,
    pId: null,
    request: {
      name: null,
      entity: null,
      type: "",
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    files: [],
    dataTable: [],
    uploadedFiles: [],
    headers: [],
    isSearch: false,
    isFirst: true,
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    showTable: false,
    dataUpdate: 0,
    dataAll: 0,
    exceptionFlag: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    sortBy: [],
    sortDesc: [],
    questionType: "",
    dialogAdd: {
      flag: false,
      id: null,
      question: "",
      answer: "",
      questionType: "",
    },
    dialogEdit: {
      flag: false,
      id: null,
      question: "",
      answer: "",
      questionType: "",
    },
    images: {
      editBtn: editBtn,
      deleteBtn: deleteBtn,
      deleteIcon: deleteIcon,
      trashIcon: trashIcon,
      saveImg: saveImg,
      questionset: questionset,
      uploadImg: uploadImg,
      excelImg: excelImg,
      processImg: processImg,
      downloadImg: downloadImg,
      normalImg: normalImg,
      chainedImg: chainedImg,
    },
    dialog_delete: false,
    deleteItem: null,
    dialog_delete1: false,
    dialog_upload: false,
    dialog_warn: false,
    selectedItems: [],
    selectAll: false,
    deleteItem: null,
    questionTypeList: [
      { name: "Normal Question", value: "Normal Question" },
      { name: "Chain Question", value: "Chain Question" },
    ],
    validMimeTypes_Excel: [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls
    ],
  }),
  watch: {
    options: {
      handler() {
        if(!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },
    'options.page': function() {
    this.selectedItems = [];
  },
  },
  methods: {
    triggerFileUpload(type) {
      // Store the selected upload type
      this.selectedUploadType = type;
      this.request.type = type;
      
      if (this.$refs.dragDropRef) {
        // Call the handleFileImport method from the DragDropFile component
        this.$refs.dragDropRef.handleFileImport();
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    Get() {
      let self = this;
      self.loadingTable = true;
      self.dialog = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.pId,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableValidationPositiveDetail(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if(dataResponse.data == undefined || dataResponse.data == null) {
              self.dataTable = [];
              self.searchTotalTable = 0;
              self.totalTable = 0;
            }
            else 
            {
              self.searchTotalTable = dataResponse.data.total;
              self.dataTable = dataResponse.data.data;
              if (
                dataResponse.data.data != undefined &&
                dataResponse.data.data != null &&
                dataResponse.data.data.length > 0
              ) {
                self.searchPositiveName = dataResponse.data.data[0].name;
              }
              self.dataTable.forEach((element) => {
                element.questionType = element.questionType == "P" ? "Positive" : "Chain";
              });
              self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
          self.showTable = true;
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    handleUploadType(type) {
      if (!this.selectedUploadType) {
        this.request.type = type;
        this.selectedUploadType = type;
      }
    },
    Save() {
      let self = this;
      if (!self.searchPositiveName || !self.request.entity) {
        self.dialog_warn = true;
        return;
      } else {
        self.showTable = false;
        self.request.name = self.searchPositiveName;
        self.dialog = true;
        try {
          self.$call.UploadValidationPositive(
            self.request,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ Successfully Processed !",
                  customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                  position: 'top',
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.isFirst = true;
                self.showTable = true;
                self.pId = dataResponse.data;
                self.searchPositiveName = self.request.name;
                self.request.entity = null;
                self.uploadedFiles = [];
                if (self.$route.query.id !== String(self.pId)) {
                  window.location.href = `${self.$route.path}?id=${self.pId}`;
                }
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } catch (error) {
          this.LogTrace(error, "DeleteGroup");
        }
      }
    },
    processUpload(e) {
    this.files = e;
    if (this.files.length == 0) {
      this.request.entity = null;
      this.uploadedFiles = [];
      this.selectedUploadType = null;
      return;
    }
    
    const reader = new FileReader();
    reader.readAsText(this.files[0]);
    reader.onload = () => {
      let text = reader.result;
      this.ValidateCSV(text, this.files);
    };
  },
    ValidateCSV(csv, files) {
  const formFile = new FormData();
  formFile.append("formFile", files[0]);
  formFile.append("questionType", this.selectedUploadType);
  
  this.$call.ValidateCSV(
    formFile,
    (dataResponse) => {
      if (dataResponse.status == 0) {
        console.log(dataResponse.data);
        if (!dataResponse.data) {
          this.uploadedFiles = [];
          this.request.entity = null;
          this.selectedUploadType = null;
          this.$swal.fire({
            icon: "warning",
            title: "Invalid file format!",
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          const formDataDoc = new FormData();
          formDataDoc.append("entity", files[0]);
          this.uploadedFiles = files;
          this.request.entity = formDataDoc;
          this.$swal.fire({
            title: "✔ Successfully Uploaded !",
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              popup: 'success-banner',
              title: 'success-banner-title'
            },
          });
        }
      } 
    },
    (errorResource) => {
      console.error("Validation error:", errorResource);
      this.$swal.fire({
        icon: "error",
        title: "Validation Failed!",
        text: "An error occurred while validating the file.",
        showConfirmButton: true,
      });
    }
  );
},
    removeFile(fileName) {
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.selectedUploadType = null;
      this.request.type = null;
      this.$emit("filesUploaded", this.uploadedFiles);
    },
    SetAdd() {
      let self = this;
      self.dialogAdd.flag = true;
      self.dialogAdd.question = "";
      self.dialogAdd.answer = "";
      self.dialogAdd.questionType = "";
    },
    ClearAdd() {
      let self = this;
      self.dialogAdd.flag = false;
      self.dialogAdd.question = "";
      self.dialogAdd.answer = "";
      self.dialogAdd.questionType = "";
    },
    Add() {
      let self = this;
      try {
        if (self.dialogAdd.question == "") {
          self.dialogAdd.flag = false;
          self.dialog_warn = true;
          return;
        } else if (self.dialogAdd.questionType == "") {
          self.dialogAdd.flag = false;
          self.dialog_warn = true;
          return;
        } else if (!self.searchPositiveName) {
          self.dialogAdd.flag = false;
          self.dialog_warn = true;
          return;
        } else {
          self.dialog = true;
          self.showTable = false;
          self.request.name = self.searchPositiveName;
          var temp = {
            name: self.pId == null ? self.searchPositiveName : self.pId,
            question: self.dialogAdd.question,
            answer: self.dialogAdd.answer,
            questionType: self.dialogAdd.questionType,
          };
          self.$call.AddValidationPositiveDetail(
            temp,
            (dataResponse) => {
              self.dialog = false;
              if (dataResponse.status == 0) {
                self.isFirst = true;
                self.showTable = true;
                self.pId = dataResponse.data;
                self.searchPositiveName = self.request.name;
                self.$swal.fire({
                  title: "✔ Positive Question Created Successfully !",
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'top',
                  customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                }).then(() => {
                  self.ClearAdd();

                  self.$router.replace({
                    query: { id: self.pId },
                  });
                });
                
              }
              
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "Add Positive Question");
      }
    },
    SetEdit(item) {
      let self = this;
      self.dialogEdit.flag = true;
      self.dialogEdit.id = item.positiveID;
      self.dialogEdit.question = item.question;
      self.dialogEdit.answer = item.answer;
      self.dialogEdit.questionType =
        item.questionType == "Positive" ? "Normal Question" : "Chain Question";
    },
    ClearEdit() {
      let self = this;
      self.dialogEdit.flag = false;
      self.dialogEdit.id = null;
      self.dialogEdit.question = "";
      self.dialogEdit.answer = "";
    },
    EditById() {
      let self = this;
      try {
        if (self.dialogEdit.question == "") {
          self.dialogEdit.flag = false;
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("_Please_Question"),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        } else if (self.dialogEdit.questionType == "") {
          self.dialogEdit.flag = false;
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: "Please specify your question type.",
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        } else {
          self.dialog = true;
          var temp = {
            positiveID: self.dialogEdit.id,
            question: self.dialogEdit.question,
            answer: self.dialogEdit.answer,
            questionType: self.dialogEdit.questionType,
          };
          self.$call.EditValidationPositiveDetail(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ Successfully Updated !",
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'top',
                  customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                });
                self.ClearEdit();
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "Edit Positive Question");
      }
    },
    DeleteById(id) {
      let self = this;
      self.deleteItem = id;
      self.dialog_delete = true;
      
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.dialog_delete1 = false;
      this.deleteItem = null;
    },
    confirmDelete() {
      let self = this;
      if (!self.deleteItem) return;

      try {
        self.dialog = true;
        self.dialog_delete = false;

        // Check if we're deleting selected items or a single item
        if (self.deleteItem === 'selected') {
          // Delete multiple selected items
          self.deleteMultipleItems();
        } else {
          // Delete single item
          self.deleteSingleItem(self.deleteItem);
        }
      } catch (error) {
        console.error('Delete error:', error);
        self.dialog = false;
      }
    },
    async deleteMultipleItems() {
    let self = this;
    self.showTable = false;
    
    let deletedCount = 0;
    let failedCount = 0;
    const itemsToDelete = [...self.selectedItems];
    
    for (const id of itemsToDelete) {
      try {
        await new Promise((resolve, reject) => {
          self.$call.DeleteValidationPositiveDetail(
            id,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                deletedCount++;
                resolve();
              } else {
                failedCount++;
                reject(new Error(dataResponse.message));
              }
            },
            (errorResource) => {
              failedCount++;
              reject(errorResource);
            }
          );
        });
      } catch (error) {
        console.error(`Failed to delete item ${id}:`, error);
      }
    }
    
    // Clear selected items
    self.selectedItems = [];
    
    // Show result message
    if (deletedCount > 0 && failedCount === 0) {
      self.$swal.fire({
        title: "✔ Text Successfully Deleted !",
        showConfirmButton: false,
        timer: 1500,
        position: 'top',
        customClass: {
          popup: 'success-banner',
          title: 'success-banner-title'
        },
      });
    } else if (deletedCount > 0 && failedCount > 0) {
      self.$swal.fire({
        icon: 'warning',
        title: 'Partial Success',
        text: `Deleted ${deletedCount} item(s), failed to delete ${failedCount} item(s)`,
        showConfirmButton: false,
        timer: 2000,
      });
    } else {
      self.$swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete all items',
        showConfirmButton: false,
        timer: 1500,
      });
    }
    
    // Refresh table
    self.isFirst = true;
    self.Get();
    self.dialog = false;
    self.showTable = true;
  },
  deleteSingleItem(id) {
    let self = this;
    self.$call.DeleteValidationPositiveDetail(
      id,
      (dataResponse) => {
        if (dataResponse.status == 0) {
          self.$swal.fire({
            title: "✔ Successfully Deleted !",
            showConfirmButton: false,
            timer: 1500,
            position: 'top',
            customClass: {
              popup: 'success-banner',
              title: 'success-banner-title'
            },
          });
          self.Get();
        }
        self.dialog = false;
        self.deleteItem = null;
      },
      (errorResource) => {
        self.dialog = false;
        self.deleteItem = null;
        console.error(errorResource);
      }
    );
  },
    toggleSelectAll() {
      if (this.selectedItems.length === this.dataTable.length) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.dataTable.map(item => item.positiveID);
      }
    },
    DeleteSelected() {
    let self = this;

    if (self.selectedItems.length === 0) {
      self.$swal.fire({
        icon: 'warning',
        title: 'No Items Selected',
        text: 'Please select at least one item to delete.',
        timer: 2000,
      });
      return;
    }

    // Set deleteItem to indicate we're deleting selected items
    self.deleteItem = 'selected';
    self.dialog_delete = true;
  },
  DeleteByName(id) {
      let self = this;
      self.deleteItem = id;
      self.dialog_delete1 = true;
    },
    confirmDelete1() {
      let self = this;
      if (!self.deleteItem) return;
      let name = self.deleteItem;
      try{
              self.dialog = true;
              self.$call.DeleteValidationPositive(
                name,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.dialog_delete1 = false;
                    self.$swal.fire({
                      title: "✔ Successfully Deleted !",
                      showConfirmButton: false,
                      timer: 1500,
                      position: 'top',
                      customClass: {
                          popup: 'success-banner',
                          title: 'success-banner-title'
                        },
                    });
                    self.Clear();
                  }
                  self.dialog = false;
                  this.$router.push("/ValidationPositive");
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Clear() {
      let self = this;
      self.showTable = false;

      self.request.entity = null;
      self.request.name = null;
      self.request.type = null;
      self.searchPositiveName = null;
      self.dataTable = [];
      self.searchTotalTable = 0;
      self.totalTable = 0;

      this.$emit("back", true);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    async normalDownload() {
      const data = [
        {
          Questions: "จังหวัดที่อยู่เหนือสุดของประเทศไทย",
          "Human Answer": "จังหวัดที่อยู่เหนือสุดของประเทศไทยคือจังหวัดเชียงราย",
        },
        {
          Questions: "จังหวัดที่อยู่ใต้สุดของประเทศไทย",
          "Human Answer": "จังหวัดที่อยู่ใต้สุดของประเทศไทยคือจังหวัดยะลา",
        },
        {
          Questions: "จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทย",
          "Human Answer": "จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทยคือจังหวัดเชียงใหม่",
        },
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 30 },
        { header: "Human Answer", key: "Human Answer", width: 50 },
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "upload_questions.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
    async chainTemplate() {
      const data = [
        {
          Questions: "จังหวัดที่อยู่เหนือสุดของประเทศไทยคือจังหวัดอะไร?",
          "Human Answer": "จังหวัดที่อยู่เหนือสุดของประเทศไทยคือจังหวัดเชียงราย",
        },
        {
          Questions: "ทำไมจังหวัดเชียงรายจึงเป็นจังหวัดที่อยู่เหนือสุดของประเทศไทย?",
          "Human Answer":
            "จังหวัดเชียงรายเป็นจังหวัดที่อยู่เหนือสุดของประเทศไทย เนื่องจากพื้นที่ของอำเภอแม่สายมีพิกัดเหนือสุดของประเทศ และมีพรมแดนติดกับประเทศเมียนมา",
        },
        {
          Questions: "จังหวัดเชียงรายมีความสำคัญทางประวัติศาสตร์และเศรษฐกิจอย่างไร?",
          "Human Answer":
            "จังหวัดเชียงรายมีความสำคัญทางประวัติศาสตร์เพราะเคยเป็นศูนย์กลางของอาณาจักรล้านนา และเป็นจุดกำเนิดของเมืองเชียงใหม่ นอกจากนี้ ยังเป็นศูนย์กลางเศรษฐกิจของภาคเหนือ มีแหล่งท่องเที่ยวสำคัญ เช่น ดอยแม่สลอง วัดร่องขุ่น และเป็นศูนย์กลางการค้าชายแดนไทย-เมียนมา",
        },
        { Questions: "#End#", "Human Answer": "#End#" },
        {
          Questions: "วิธีทำไข่เจียวแบบง่ายๆ ต้องใช้อะไรบ้าง?",
          "Human Answer":
            "การทำไข่เจียวแบบง่ายๆ ใช้ไข่ไก่ 2 ฟอง น้ำปลา 1 ช้อนชา น้ำมันสำหรับทอด และอาจเติมต้นหอมซอยหรือหอมแดงเพื่อเพิ่มรสชาติ",
        },
        {
          Questions: "ทำอย่างไรให้ไข่เจียวฟูและกรอบนอกนุ่มใน?",
          "Human Answer":
            "เพื่อให้ไข่เจียวฟูและกรอบนอกนุ่มใน ควรตีไข่ให้ขึ้นฟองอากาศก่อนทอด ใช้น้ำมันร้อนจัด และทอดในน้ำมันที่มีปริมาณมากพอให้ไข่ลอยตัว อีกทั้งสามารถเติมน้ำเย็นหรือน้ำโซดาลงไปเล็กน้อยขณะตีไข่เพื่อเพิ่มความฟู",
        },
        {
          Questions: "กระบวนการทางวิทยาศาสตร์ที่ทำให้ไข่เจียวฟูมีอะไรบ้าง?",
          "Human Answer":
            "ไข่เจียวฟูเกิดจากการดักจับฟองอากาศในไข่ขณะตี เมื่อเจอกับความร้อน อากาศที่ติดอยู่ขยายตัว ทำให้ไข่เจียวพองขึ้น นอกจากนี้ โปรตีนในไข่ขาวจะเกิดการ Denaturation (การเปลี่ยนแปลงโครงสร้างของโปรตีน) และ Coagulation (การแข็งตัวของโปรตีน) ทำให้ไข่เซ็ตตัวและรักษารูปทรงฟูไว้",
        },
        { Questions: "#End#", "Human Answer": "#End#" },
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 50 },
        { header: "Human Answer", key: "Human Answer", width: 70 },
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Chain_template.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
  },
  mounted() {
    this.GetDate();
    this.headers = [
      { 
        title: '', 
        key: 'select', 
        align: 'center', 
        sortable: false,
        width: '60px'
      },
      {
        title: this.$t("no"),
        align: "center",
        sortable: false,
      },
      { title: "Question", align: "left", sortable: true, value: "Question" },
      { title: "Human Answer", align: "left", sortable: true, value: "Answer" },
      { title: "Type", align: "center", sortable: true, value: "questionType" },
      { title: this.$t("action"), align: "center", sortable: false, width: "150px" },
    ];
    if (this.$route.query.id) {
      this.searchPositiveName = this.$route.query.id;
      this.pId = this.$route.query.id;
      this.showTable = true;
      this.actionEdit = true;
    }
    this.Get();
    this.isInitialized = true;
  },
};
</script>
<style scoped>
/* =============================================================================
   MAIN LAYOUT STYLES
   ============================================================================= */
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.text-ellipsis {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =============================================================================
   MODERN TEXT FIELD STYLES
   ============================================================================= */
.modern-text-field {
  margin-top: 8px;
}

.modern-text-field :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-text-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Read-only state */
.modern-text-field :deep(.v-field--readonly) {
  background: #f8f9fa !important;
  opacity: 0.9;
}

.modern-text-field :deep(.v-field--readonly .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.08) !important;
  border-style: dashed !important;
}

.modern-text-field :deep(.v-field--readonly:hover .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

/* Label styling */
.modern-text-field :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-text-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-text-field :deep(.v-field--readonly .v-label) {
  color: #6c757d !important;
}

/* Input text styling */
.modern-text-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-text-field :deep(.v-field--readonly .v-field__input) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
}

/* Icon styling */
.modern-text-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-text-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* =============================================================================
   FILES DISPLAY STYLES
   ============================================================================= */
.files-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  transition: all 0.2s ease;
}

.files-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.3);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08);
}

.files-card .v-card-title {
  background: rgba(var(--v-theme-surface-variant), 0.3);
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.file-item {
  transition: background-color 0.2s ease;
}

.file-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.file-item .v-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
}

/* Custom scrollbar */
.v-virtual-scroll::-webkit-scrollbar {
  width: 4px;
}

.v-virtual-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.v-virtual-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(var(--v-theme-on-surface), 0.2);
  border-radius: 2px;
}

.v-virtual-scroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.3);
}

/* =============================================================================
   BUTTON STYLES
   ============================================================================= */
.template-btn {
  text-transform: none;
  font-weight: 500;
  transition: all 0.3s ease;
  border-radius: 10px;
  border: 1px solid #C32E0E;
  background: var(--White, #FFF);
  color: #C32E0E;
  margin-right: 5px;
}

.template-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.3);
  background: #FDE4DF;
}

.template-item {
  display: flex;
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
  margin: 2px 4px;
}

.template-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.08);
  transform: translateX(4px);
}

.process-btn {
  background: #3859D0;
  border-radius: 10px;
  min-width: 100px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-right: 10px;
  color: white;
}

.process-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.process-btn:disabled {
  color: white;
  opacity: 0.6;
  cursor: not-allowed;
  background: #C1C3CB;
}

.add-btn {
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(var(--v-theme-primary), 0.3);
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(var(--v-theme-primary), 0.4);
}

/* =============================================================================
   DATA TABLE STYLES
   ============================================================================= */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* =============================================================================
   DIALOG STYLES
   ============================================================================= */
.modern-dialog {
  margin: 24px;
  animation: dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2) !important;
}

/* Dialog Header */
/* .dialog-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  padding: 24px !important;
  position: relative;
  border-bottom: none !important;
}

.header-icon-container {
  background: rgba(25, 118, 210, 0.1);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.header-text {
  flex: 1;
}
*/
/* .dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
}

.dialog-subtitle {
  font-size: 0.875rem !important;
  color: #6c757d !important;
  margin: 0 !important;
  font-weight: 400 !important;
} */
/*
.close-btn {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 50% !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  transform: scale(1.1) !important;
} */

/* Dialog Content */
.dialog-content {
  padding: 32px 24px !important;
  background: #ffffff;
}

.field-container {
  margin-bottom: 16px;
}

/* Modern field and textarea shared styles */
.modern-field :deep(.v-field__outline),
.modern-textarea :deep(.v-field__outline) {
  border-radius: 12px !important;
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field--focused .v-field__outline),
.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-field :deep(.v-field),
.modern-textarea :deep(.v-field) {
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-field:hover :deep(.v-field__outline),
.modern-textarea:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-field :deep(.v-label),
.modern-textarea :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-field :deep(.v-field--focused .v-label),
.modern-textarea :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-field :deep(.v-field__input),
.modern-textarea :deep(.v-field__input) {
  font-size: 16px !important;
  font-weight: 400 !important;
  color: #171717 !important;
  padding: 16px 12px !important;
}

.modern-field :deep(.v-field__input::placeholder),
.modern-textarea :deep(.v-field__input::placeholder) {
  color: #CCC !important;
}

.modern-field :deep(.v-field__prepend-inner),
.modern-textarea :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-field :deep(.v-field__append-inner),
.modern-textarea :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* =============================================================================
   ACTION BANNER STYLES
   ============================================================================= */
.action-banner {
  margin: 24px 0 16px 0;
  padding: 0 8px;
}

.banner-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08) !important;
  transition: all 0.3s ease;
}

.banner-card:hover {
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08) !important;
}

.banner-content {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 16px !important;
  padding: 16px 24px !important;
  min-height: 60px;
}

.delete-all-btn {
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 140px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 16px;
  border: 1px solid var(--main, #C32E0E);
  background: rgba(195, 0, 0, 0.10);
  color: #C32E0E !important;
}

.delete-all-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.08) !important;
  border-color: rgb(var(--v-theme-error)) !important;
  transform: translateY(-2px) !important;
}

.delete-all-btn:active {
  transform: translateY(0) !important;
}

.back-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%) !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  color: white !important;
}

.back-btn:hover {
  background: linear-gradient(135deg, #f57c00 0%, #e65100 100%) !important;
  transform: translateY(-2px) !important;
}

.back-btn .v-icon {
  color: white !important;
}

/* Enhanced hover states for banner buttons */
.delete-all-btn .v-icon,
.back-btn .v-icon {
  transition: transform 0.2s ease !important;
}

.delete-all-btn:hover .v-icon {
  transform: scale(1.1) rotate(-5deg) !important;
}

.back-btn:hover .v-icon {
  transform: scale(1.1) translateX(-2px) !important;
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
@keyframes dialogSlideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 960px) {
  .d-flex.justify-end {
    justify-content: center !important;
  }
  
  .process-btn,
  .add-btn {
    min-width: 120px;
  }
}

@media (max-width: 768px) {
  /* Action Banner */
  .action-banner {
    margin: 16px 0 12px 0;
    padding: 0 4px;
  }
  
  .banner-content {
    padding: 12px 16px !important;
    gap: 12px !important;
    flex-direction: column-reverse !important;
    align-items: stretch !important;
  }
  
  .delete-all-btn,
  .back-btn {
    width: 100% !important;
    min-width: auto !important;
    justify-content: center !important;
  }
  
  .delete-all-btn {
    order: 2;
  }
  
  .back-btn {
    order: 1;
  }

  /* Dialog Responsive */
  .dialog-header {
    padding: 20px 16px !important;
  }
  
  .header-icon-container {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }
  
  .dialog-title {
    font-size: 1.25rem !important;
  }
  
  .dialog-content {
    padding: 24px 16px !important;
  }
  
  .dialog-actions {
    padding: 16px !important;
    flex-direction: column;
  }
  
  .cancel-btn,
  .save-btn,
  .save-edit-btn {
    width: 100% !important;
    min-width: auto !important;
  }

  .modern-field :deep(.v-field__input),
  .modern-textarea :deep(.v-field__input) {
    font-size: 0.9rem !important;
    padding: 14px 10px !important;
  }
  
  .modern-field :deep(.v-label),
  .modern-textarea :deep(.v-label) {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 600px) {
  .ga-3 {
    gap: 0.5rem !important;
  }
  
  .process-btn,
  .add-btn {
    font-size: 0.875rem;
    min-width: 100px;
  }

  .banner-content {
    gap: 8px !important;
  }
  
  .delete-all-btn,
  .back-btn {
    font-size: 0.875rem !important;
    padding: 12px 16px !important;
  }
  
  .back-btn {
    letter-spacing: 0.5px !important;
  }
}
.form-container {
  background: white;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin: 15px;
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-pagination__first),
:deep(.v-pagination__last) {
  display: none !important;
}

:deep(.v-pagination__list) {
  gap: 4px;
}
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
.custom{
  display: flex;
  align-items: center;
  gap: 5px;
}
.customimg{
  max-width: 30px!important;
}
.hidden-upload {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}
.upload-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}
/* Main Upload Button */
.upload-main-btn {
  position: relative;
  z-index: 2;
  border-radius: 12px !important;
  /* font-weight: 600 !important; */
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  padding: 0 24px !important;
  height: 48px !important;
  background-color: transparent !important;
  border: 1px solid rgba(195, 46, 14, 0.8) !important ;
  color:#C32E0E ;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

.upload-main-btn:hover {
  box-shadow: 0 6px 20px rgba(195, 46, 14, 0.35) !important;
  transform: translateY(-1px);
}

.upload-main-btn:active {
  transform: translateY(0);
}

.upload-text {
  font-size: 1rem;
  font-weight: 400;
}

/* Upload Info Section */
.upload-info {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 2;
}

.upload-description {
  display: flex;
  align-items: center;
  gap: 4px;
}

.upload-hint {
  font-size: 0.875rem;
  color: #646464;
  font-weight: 500;
}

.upload-help-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
}

.upload-help-btn:hover {
  opacity: 1;
  background: rgba(25, 118, 210, 0.1);
}

.upload-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}
.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px;
  border: 1px dashed #949AA8;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(255, 242, 242, 1) 0%, rgba(255, 255, 255, 1) 100%);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  width: 100% !important;
}

.upload-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 242, 242, 01) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-area:hover {
  border-color:  rgba(255, 242, 242, 1);
  background: linear-gradient(135deg, rgba(255, 242, 242, 1) 0%, rgba(255, 255, 255, 1) 100%);
  /* transform: translateY(-2px); */
  box-shadow: 0 6px 15px rgb(251, 236, 236);
}

.upload-area:hover::before {
  opacity: 1;
}
.upload-section {
  align-items: center;
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
/* Uploaded File Info */
.uploaded-file-info {
  position: relative;
  z-index: 2;
  animation: fadeInUp 0.3s ease;
}

.file-chip {
  font-weight: 500 !important;
  max-width: 280px;
  background: #ffffff!important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #000000;
}
.file-chip .v-chip--variant-tonal .v-chip__underlay{
  background: #ffffff!important;
}

.file-chip :deep(.v-chip__content) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:deep(i.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-select__menu-icon) {
  color: #C32E0E !important;
  opacity: 1 !important;
}
</style>
